import { service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterTransitionService from 'garaje/services/router-transition';

interface SideBarLocationMenuMapsMenuComponentSignature {
  Args: {
    trackClickEvent: unknown;
  };
}

export default class SideBarLocationMenuMapsMenuComponent extends Component<SideBarLocationMenuMapsMenuComponentSignature> {
  @service declare routerTransition: RouterTransitionService;

  isPendingForRoute = (route: string, currentWhen?: string): boolean => {
    return this.routerTransition.isPendingForRoute(route, currentWhen);
  };

  /**
   * True when the in-flight transition's target is somewhere under
   * `spaces.maps.*`. Used to suppress the old sub-link's `aria-current`
   * highlight as soon as a maps-to-maps click happens, so only the new
   * (pending) link looks active.
   */
  get hasPendingMapsTransition(): boolean {
    const pending = this.routerTransition.pendingRouteName;
    if (!pending) return false;
    return pending === 'spaces.maps' || pending.startsWith('spaces.maps.');
  }
}
